
export const SERVICE_ACTION = {
  SERVICE: "Service",
  REPLACEMENT: "Replacement",
  CANCEL: "Cancel",
};

export const SERVICE_ACTION_OPTIONS = [
  { value: "", label: "Select Action" },
  { value: SERVICE_ACTION.SERVICE, label: "Service" },
  { value: SERVICE_ACTION.REPLACEMENT, label: "Replacement" },
  { value: SERVICE_ACTION.CANCEL, label: "Cancel" },
];

export const SERVICE_STATUS = {
  CREATED: "Created",
  ASSIGNED: "Assigned",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

export const SERVICE_ACTION_CALL_STATUS = {
  SERVICE: "Service",
  SERVICE_ASSIGNED: "Service Assigned",
  ASSIGN_TO_STORE: "Assign To Store",
  SERVICE_IN_PROGRESS: "Service In Progress",
  SERVICE_COMPLETED: "Service Completed",
  RETURNING_TO_STORE: "Returning To Store",
  SERVICE_CLOSED: "Service Closed",
};

export const JOB_STATUS = {
  PENDING: "Pending",
  DONE: "Done",
  NOT_DONE: "Not Done",
};

export const COLLECTION_STATUS = {
  PENDING: "Pending",
  COLLECTED: "Collected",
  ACCEPTED: "Accepted",
  WAIVED: "Waived",
};

export const FINANCE_STATUS = {
  PENDING: "Pending",
  CONFIRMED: "Confirmed",
  REJECTED: "Rejected",
};

export const ROLES = {
  DISPATCH: "DISPATCH",
  STORE: "STORE",
  SERVICE_EXECUTIVE: "SERVICE-EXECUTIVE",
  FI_EXECUTIVE: "FI-EXECUTIVE",
  SALES_PCD: "SALES-PCD",
  SALES_ADMIN: "SALES-ADMIN",
};

export const PAYMENT_MODE_OPTIONS = [
  { value: "Cash", label: "Cash" },
  { value: "UPI", label: "UPI" },
  { value: "Card", label: "Card" },
  { value: "Cheque", label: "Cheque" },
  { value: "Bank Transfer", label: "Bank Transfer" },
];

export const SERVICE_PASS_TO_OPTIONS = [
  { value: "M1D - HO DELHI", label: "M1D - HO DELHI" },
  { value: "M1D - BANGALORE", label: "M1D - BANGALORE" },
  { value: "M1D - MUMBAI", label: "M1D - MUMBAI" },
  { value: "M1D - HYDERABAD", label: "M1D - HYDERABAD" },
  { value: "M1D - CHENNAI", label: "M1D - CHENNAI" },
];
